export default defineNuxtPlugin(() => {
  const tablet = 768;
  const desktop = 1024;
  const desktopM = 1200;
  const desktopL = 1600;
  const desktopXL = 1920;

  const breakpoints = {
    mobile: `(max-width: ${tablet - 1}px)`,
    tablet: `(min-width: ${tablet}px) and (max-width: ${desktop - 1}px)`,
    desktop: `(min-width: ${desktop}px) and (max-width: ${desktopM - 1}px)`,
    desktopM: `(min-width: ${desktopM}px) and (max-width: ${desktopL - 1}px)`,
    desktopL: `(min-width: ${desktopL}px) and (max-width: ${desktopXL - 1}px)`,
    desktopXL: `(min-width: ${desktopXL}px)`,
  };

  const mq = reactive({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    isDesktopM: false,
    isDesktopL: false,
    isDesktopXL: false,
    isMobileOrTablet: false,
    currentDevice: 'unknown',
  });

  const mediaQueries = {};

  const updateCurrentDevice = () => {
    const deviceMap = {
      isMobile: 'mobile',
      isTablet: 'tablet',
      isDesktop: 'desktop',
      isDesktopM: 'desktopM',
      isDesktopL: 'desktopL',
      isDesktopXL: 'desktopXL',
    };

    const activeDevice = Object.entries(deviceMap).find(([key]) => mq[key]);
    mq.currentDevice = activeDevice ? activeDevice[1] : 'unknown';
    mq.isMobileOrTablet = mq.isMobile || mq.isTablet;
  };

  function setupMediaQuery(name, query) {
    const mediaQuery = window.matchMedia(query);

    const update = e => {
      mq[name] = e.matches;
      updateCurrentDevice();
    };

    mediaQuery.addEventListener('change', update);
    mq[name] = mediaQuery.matches;

    mediaQueries[name] = { mediaQuery, update };
  }

  if (process.client) {
    Object.entries(breakpoints).forEach(([name, query]) => {
      const key = 'is' + name.charAt(0).toUpperCase() + name.slice(1);
      setupMediaQuery(key, query);
    });

    updateCurrentDevice();
  }

  if (process.client) {
    onBeforeUnmount(() => {
      Object.values(mediaQueries).forEach(({ mediaQuery, update }) => {
        mediaQuery.removeEventListener('change', update);
      });
    });
  }

  return { provide: { mq } };
});
